import { hi } from 'date-fns/locale'
import { getRequiredFields } from 'utils/form'

const fields = [
  {
    label: 'Partner name',
    name: 'partnerName',
    layout: 'fullWidth',
    disabled: true,
  },
  {
    label: 'Counselling partner',
    name: 'counsellingPartner',
    layout: 'fullWidth',
    disabled: true,
  },
  {
    label: 'Business leader',
    name: 'businessLeader',
    layout: 'fullWidth',
    disabled: true,
  },  
  {
    label: 'Offering portfolio lead',
    name: 'offeringPortfolioLeader',
    layout: 'fullWidth',
    disabled: true,
  },
  {
    label: 'Business COO',
    name: 'businessCOO',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Offering lead',
    name: 'offeringLeader',
    layout: 'fullWidth',
    disabled: true,
  },
  {
    label: 'Market leader',
    name: 'marketLeader',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: false,
    options: [],
    searchable: true,
  },
  {
    label: 'Growth leader',
    name: 'clientIndustryLeader',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: false,
    options: [],
    searchable: true,
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/PartnerHierarchyForm.js